import { Mic } from "lucide-react";

export function BotonMicrofono({ grabando, disabled, onClick, testid = "asistente-mic" }) {
  const etiqueta = grabando ? "Detener y enviar" : "Hablar con el asistente";
  return (
    <button type="button" onClick={onClick} disabled={disabled && !grabando} aria-label={etiqueta} title={etiqueta} aria-pressed={grabando}
      className={`relative h-10 w-10 shrink-0 rounded-xl border flex items-center justify-center transition-colors disabled:opacity-50 ${grabando ? "bg-rose-600 border-rose-600 text-white" : "bg-white border-slate-200 text-[#00B4CC] hover:border-[#00B4CC] hover:bg-[#00B4CC]/10"}`}
      data-testid={testid} data-state={grabando ? "grabando" : "inactivo"}>
      {grabando && <span className="absolute inset-0 rounded-xl bg-rose-500/40 animate-ping" />}
      <Mic className="relative w-4 h-4" />
    </button>
  );
}
